module.exports = __webpack_public_path__ + "img/loginload.afb80ba6.svg";